// The property chooser, rendered only when the account has more than one home
// (the app's word for a home is "property"; the API's is kept for identifiers). A
// native <select> is used deliberately: it is keyboard- and screen-reader-
// accessible out of the box and needs no custom focus management.
//
// homes:      the home objects to list (raw homeList.homes slice: id + friendlyName).
// selectedId: the currently selected home id (a valid id, already resolved by the
//             caller against the user's own homes).
// onSelect:   called with the chosen home id.
export default function HomeSelector({ homes, selectedId, onSelect }) {
  return (
    <div className="home-selector">
      <label htmlFor="home-select">Property</label>
      <select
        id="home-select"
        value={selectedId ?? ''}
        onChange={(event) => onSelect(event.target.value)}
      >
        {homes.map((home) => (
          <option key={home.id} value={home.id}>
            {home.friendlyName || home.id}
          </option>
        ))}
      </select>
    </div>
  );
}
